export default __webpack_public_path__ + "static/media/NoSolution.05182953.png";